const LOCATION_SECTION_REQUIRED_FIELDS = ['address', 'name', 'phoneNumber'];

export default LOCATION_SECTION_REQUIRED_FIELDS;
